// extracted by mini-css-extract-plugin
module.exports = {"button":"Apps_button__3ZUXr","openButton":"Apps_openButton__2AlQp","buttonIcon":"Apps_buttonIcon__3F_5L"};